import React, { useEffect, useState } from 'react';

import { images } from '../../constants';
import { AppWrap, MotionWrap } from '../../wrapper';
import './Footer.scss';
import axios from "axios";

const Footer = () => {
  const [error, setError] = useState('')
  const [data, setData] = useState({
    name: "",
    desc: "",
    phone_number:"",
    email: "",
  });
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  
  
  const handleChange = (event) => {
    const { name, value } = event.target;
    setData({
      ...data,
      [name]: value,
    });
  };

  const url = "https://portofolio1.onrender.com";

  const handleSubmit = async(event)=>{
    event.preventDefault();
    try{
      setLoading(true);
      const response = await axios.post(url+"/client", data);
      response.status=== 201 && setIsFormSubmitted(true);
      setLoading(false);
    }catch(err){
     setError(err.message);
     setLoading(false);
     console.log(err)
    }
    
    /* if (response.status === 201) {
      alert("Contact created successfully!");
    } else {
      alert("Error creating contact.");
    } */
  };

  

  return (
    <>
      <h2 className="head-text">Take a coffee & chat with me</h2>

      <div className="app__footer-cards">
        <div className="app__footer-card ">
          <img src={images.email} alt="email" />
          <a href="mailto:yatef57@gmail.com" className="p-text">yatef57@gmail.com</a>
        </div>
        <div className="app__footer-card">
          <img src={images.mobile} alt="phone" />
          <a href="tel:+20 (155) 449-0934" className="p-text">+20 (155) 449-0934 </a>
        </div>
      </div>
      {!isFormSubmitted ? (
        <div className="app__footer-form app__flex">
          <div className="app__flex">
            <input className="p-text" type="text" placeholder="Your Name" name="name"   value={data.name}  onChange={handleChange} />
          </div>
          <div className="app__flex">
            <input className="p-text" type="email" placeholder="Your Email" name="email"  value={data.email}  onChange={handleChange} />
          </div>
          <div className="app__flex">
            <input className="p-text" type="text" placeholder="Phone number" name="phone_number"  value={data.phone_number}  onChange={handleChange} />
          </div>
          <div>
            <textarea
              className="p-text"
              placeholder="Your Message"
               value={data.desc} 
              name="desc"
              onChange={handleChange}
            />
          </div>
          <button type="button" className="p-text" onClick={handleSubmit}> {!loading ? 'Send Message' : 'Sending...'} </button>
        </div>
      ) : (!error ? (
        <div>
          <h3 className="head-text">
            Thank you for getting in touch!  
          </h3>
        </div>
      ):(
        error && <div>{error}</div>
      )
      )}
    </>
  );
};

export default AppWrap(
  MotionWrap(Footer, 'app__footer'),
  'contact',
  'app__whitebg',
);
